var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEducationIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.084,
  cy: 20,
  fill: "#FFF09F",
  rx: 20.045,
  ry: 20
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#EducationIco_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.37 23.938c-.37 0-.917-.041-1.419-.234l-4.013-1.546h-1.965v2.408c0 .74.55 1.58 1.23 1.876l4.858 2.114c.679.295 1.781.296 2.46.003l4.912-2.12c.68-.294 1.23-1.133 1.23-1.873v-2.408h-2.169l-3.555 1.5c-.428.18-.986.28-1.569.28"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.517 19.015 9.676 3.729c.691.265 1.804.248 2.486-.04l9.24-3.895v5.747l-.57 1.905H32l-.59-1.925v-5.96h-.016c.399-.275.306-.618-.285-.829l-9.401-3.345c-.698-.249-1.825-.238-2.518.022L9.521 18.06c-.693.26-.695.688-.004.954"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "EducationIco_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 10h23v23H9z"
})))));
export default SvgEducationIco;